// @ts-nocheck

import { createSelector } from 'reselect';

import { type StateType } from '../../../states';
import { type Selector } from '../../../types/selectors';
import { BoomNotificationsTypes, type BoomNotificationState } from '../types/notification';

import { selectBoomMiscTmpNotifications } from './misc/miscPrimary.selector';
import { selectBoomUserNotifications } from './user/userPrimary.selector';

export const selectBoomNotificationUuids: Selector<Array<string>> = createSelector(
  [selectBoomUserNotifications],
  (notifications) =>
    notifications.reduce(
      (acc, notification) =>
        notification.type === BoomNotificationsTypes.STEP_COMPLETED ? [...acc, notification.uuid] : acc,
      [],
    ),
);

export const selectBoomFirstTmpNotification: Selector<BoomNotificationState | null> = (state: StateType) =>
  selectBoomMiscTmpNotifications(state)[0] ?? null;

export const selectBoomHasPendingNotifications: Selector<boolean> = (state: StateType) =>
  !!selectBoomMiscTmpNotifications(state).length;
